module.exports = __webpack_public_path__ + "images/apple-touch-icon-114x114-ccf78421e12c1b31807d588bde43ac4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/apple-touch-icon-114x114.png
// module id = ./src/images/favicons/apple-touch-icon-114x114.png
// module chunks = 1